import React from "react";
import {Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Grid} from "@material-ui/core";

const CabinetDetails = ({open, onClose, cabinet}) => {
  if (!cabinet) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Cabinet Details</DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          {/* ID */}
          <Grid item xs={12}>
            <Typography variant="subtitle2" color="textSecondary">
              Cabinet ID
            </Typography>
            <Typography>{cabinet.id}</Typography>
          </Grid>

          {/* Code */}
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              SN
            </Typography>
            <Typography>{cabinet.sn || "—"}</Typography>
          </Grid>

          {/* Type */}
          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Type
            </Typography>
            <Typography>{cabinet.typeName || cabinet.type?.name || "—"}</Typography>
          </Grid>

          {/* Store Info */}
          <Grid item xs={12} style={{marginTop: 16}}>
            <Typography variant="h6">Store Info</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Store Name
            </Typography>
            <Typography>{cabinet.location_name || "—"}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Store Code
            </Typography>
            <Typography>{cabinet.location_code || "—"}</Typography>
          </Grid>

          {/* Temps */}
          <Grid item xs={12} style={{marginTop: 16}}>
            <Typography variant="h6">Details</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Is New
            </Typography>
            <Typography>{cabinet.is_new || cabinet.is_new == "TRUE" ? "YES" : "NO"}</Typography>
          </Grid>

          <Grid item xs={6}>
            <Typography variant="subtitle2" color="textSecondary">
              Booked
            </Typography>
            <Typography>{cabinet.booked || cabinet.booked == "TRUE" ? "YES" : "NO"}</Typography>
          </Grid>

          {/* Last Update */}
          <Grid item xs={12} style={{marginTop: 16}}>
            <Typography variant="subtitle2" color="textSecondary">
              condition
            </Typography>
            <Typography>
              {cabinet.condition}
              {/* {cabinet.updated_at ? new Date(cabinet.updated_at).toLocaleString() : "—"} */}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CabinetDetails;
